import React from "react";
import { VegaBox, VegaCard, VegaFlex } from "@heartlandone/vega-react";
import ActivityCharge from "../ActivityInformations/Charge";
import ActivityState from "../ActivityInformations/State";
import ActivityTitle from "../ActivityInformations/Title";
import ActivityTimeRange from "../ActivityInformations/TimeRange";
import ActivityAddress from "../ActivityInformations/Address";
import ActivityParticipants from "../ActivityInformations/Participants";
import ActivityGuest from "../ActivityInformations/Guest";
import ActivityCoverImage from "../ActivityInformations/CoverImage";
import ActivityActions from "../ActivityActions/Index";
import ActivityCategory from "../ActivityInformations/Category";

function PublishedActivityListItem({ activity }) {
  const {
    city,
    address,
    activityStatus,
    isOnlineActivity,
    chargeAmount = 0,
    endTime,
    startTime,
    participantsCount = 0,
    registerNumberLimit,
    title,
    coverUrl,
    publisherCategory,
    isAllowInviteGuests,
    registerNumberLimitType,
  } = activity;
  return (
    <VegaCard padding="size-24" variant="border">
      <VegaFlex justifyContent="space-between">
        <VegaFlex direction={"col"} gap={"size-12"}>
          <VegaFlex gap={"size-8"}>
            <ActivityState state={activityStatus} />
            <ActivityCategory category={publisherCategory} />
            <ActivityCharge chargeAmount={chargeAmount} />
          </VegaFlex>
          <VegaFlex direction="col" gap="size-16">
            <ActivityTitle state={activityStatus} title={title} />
            <ActivityTimeRange startTime={startTime} endTime={endTime} />
            <ActivityAddress
              online={isOnlineActivity}
              address={address}
              city={city}
            />
            <ActivityParticipants
              currentCount={participantsCount}
              limitCount={registerNumberLimit}
              registerNumberLimitType={registerNumberLimitType}
            ></ActivityParticipants>
            <ActivityGuest isAllowInviteGuests={isAllowInviteGuests}></ActivityGuest>
          </VegaFlex>
        </VegaFlex>
        <ActivityCoverImage
          imageUrl={coverUrl || activity?.cover?.url}
          width="280px"
          height="140px"
          borderRadius="12px"
        />
      </VegaFlex>
      <VegaBox margin={{ top: "size-16" }}>
        <ActivityActions activity={activity}/>
      </VegaBox>
    </VegaCard>
  );
}

export default PublishedActivityListItem;
